/* BULANI: preserve the original frames; load motion only after interaction. */
(function () {
  document.querySelectorAll('[id^="BulaniScrub-"]').forEach(function (root) {
    if (root.dataset.bsInitialized) return;
    root.dataset.bsInitialized = 'true';
    // Phones use the existing HTML poster: no canvas allocation or frame queue.
    if (window.matchMedia('(max-width: 749px)').matches) {
      root.classList.add('bs-static');
      root.dataset.bsMode = 'mobile-static';
      root.dataset.bsRequested = '0';
      return;
    }
    var canvas = root.querySelector('[data-bs-canvas]');
    var ctx = canvas && canvas.getContext('2d');
    if (!ctx) return; // The HTML poster and shopping links remain usable.
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 749px)');
    var connection = navigator.connection;
    var staticMode = motion.matches || !!(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType)));
    root.classList.toggle('bs-static', staticMode);
    root.dataset.bsMode = staticMode ? 'static' : 'interactive';
    var ext = (root.dataset.ext || 'jpg').replace('.', '');
    var pad = parseInt(root.dataset.pad, 10) || 4;
    var requests = 0;
    function frameSet(base, count, prefix) {
      return {base:base || '',count:parseInt(count,10)||0,prefix:prefix,images:[],queue:[],requested:new Set(),inflight:0,warmed:false};
    }
    var desktop = frameSet(root.dataset.base,root.dataset.count,root.dataset.prefix || 'frame_');
    var portrait = frameSet(root.dataset.mbase,root.dataset.mcount,root.dataset.mprefix || 'frameM_');
    function active() { return mobile.matches && portrait.base && portrait.count ? portrait : desktop; }
    function clamp(v,a,b) { return Math.max(a,Math.min(b,v)); }
    function usable(img) { return img && img.complete && img.naturalWidth > 0; }
    var currentSet = null, currentFrame = -1, lastP = 0, ticking = false;
    function resize() {
      var stage = root.querySelector('.bs-stage');
      var dpr = Math.min(window.devicePixelRatio || 1,2);
      canvas.width = Math.round(stage.clientWidth*dpr);
      canvas.height = Math.round(stage.clientHeight*dpr);
      ctx.setTransform(dpr,0,0,dpr,0,0);
      currentFrame = -1;
    }
    function draw(img) {
      var dpr = Math.min(window.devicePixelRatio || 1,2);
      var cw=canvas.width/dpr,ch=canvas.height/dpr,ir=img.naturalWidth/img.naturalHeight,cr=cw/ch;
      var dw=ir>cr?ch*ir:cw,dh=ir>cr?ch:cw/ir;
      var dx=(cw-dw)/2,dy=(ch-dh)/2*(ir>1.2?0.86:1);
      ctx.clearRect(0,0,cw,ch);
      ctx.drawImage(img,dx,dy,dw,dh);
    }
    function enqueue(set,index,priority) {
      if (index<0 || index>=set.count || !set.base || set.requested.has(index)) return;
      var existing=set.queue.indexOf(index);
      if(existing>=0) { if(!priority)return; set.queue.splice(existing,1); }
      if(priority)set.queue.unshift(index);else set.queue.push(index);
    }
    function pump(set) {
      while(set.inflight<2 && set.queue.length) {
        var index=set.queue.shift();
        if(set.requested.has(index))continue;
        set.requested.add(index);set.inflight++;
        var img=new Image();
        set.images[index]=img;
        img.decoding='async';img.fetchPriority=index===0?'high':'low';
        requests++;root.dataset.bsRequested=String(requests);
        (function (image, frame) {
          function settle() {
            set.inflight--;
            if(set===active())render(lastP);
            pump(set);
          }
          image.onload=settle;
          image.onerror=settle; // Failed images are never passed to drawImage.
          image.src=set.base+set.prefix+String(frame+1).padStart(pad,'0')+'.'+ext;
        })(img,index);
      }
    }
    function render(p) {
      var set=active();
      if(currentSet!==set){currentSet=set;currentFrame=-1;enqueue(set,0,true);}
      var target=staticMode?0:clamp(Math.round(p*(set.count-1)),0,set.count-1);
      if(set.warmed) {
        enqueue(set,target+1,true);enqueue(set,target-1,true);enqueue(set,target,true);
      }
      var chosen=target;
      if(!usable(set.images[chosen])) {
        chosen=-1;
        for(var delta=1;delta<set.count;delta++) {
          if(usable(set.images[target-delta])){chosen=target-delta;break;}
          if(usable(set.images[target+delta])){chosen=target+delta;break;}
        }
      }
      if(chosen>=0 && usable(set.images[chosen]) && chosen!==currentFrame) {
        draw(set.images[chosen]);currentFrame=chosen;
      }
      pump(set);
    }
    function progress() {
      var range=root.offsetHeight-window.innerHeight;
      return range>0?clamp(-root.getBoundingClientRect().top/range,0,1):0;
    }
    function warm(set) {
      if(staticMode || set.warmed)return;
      set.warmed=true;
      // Coarse frames arrive first, then the intervening frames fill in.
      for(var i=0;i<set.count;i+=4)enqueue(set,i,false);
      for(var j=0;j<set.count;j++)enqueue(set,j,false);
    }
    function onScroll() {
      var bounds=root.getBoundingClientRect();
      if(bounds.bottom<=0 || bounds.top>=window.innerHeight)return;
      lastP=progress();warm(active());
      if(!ticking) { ticking=true;requestAnimationFrame(function(){ticking=false;render(lastP);}); }
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',function(){resize();render(lastP);},{passive:true});
    var onMobile=function(){resize();render(progress());};
    if(mobile.addEventListener)mobile.addEventListener('change',onMobile);
    else if(mobile.addListener)mobile.addListener(onMobile);
    resize();render(0);
  });
})();
